import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Scales, Eye, FloppyDisk } from "@phosphor-icons/react";
import { AdminShell } from "@/components/AdminShell";
import api, { errDetail } from "@/lib/api";

export default function AdminLegal() {
  const [key, setKey] = useState("privacy");
  const [doc, setDoc] = useState(null);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setDoc(null);
    api.get(`/legal/${key}`).then((r) => { setDoc(r.data); setTitle(r.data.title); setContent(r.data.content); })
      .catch((e) => toast.error(errDetail(e)));
  }, [key]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/admin/legal/${key}`, { title, content });
      toast.success("Saved — the public page is updated");
      const { data } = await api.get(`/legal/${key}`);
      setDoc(data);
    } catch (e) { toast.error(errDetail(e)); }
    setSaving(false);
  };

  return (
    <AdminShell title="Legal Pages" subtitle="Edit the public Privacy Policy and Terms & Conditions. Changes go live immediately." testId="admin-legal-page">
      <div className="flex items-center gap-2 mb-4 flex-wrap">
        {[["privacy", "Privacy Policy", "/privacy-policy"],
          ["terms", "Terms & Conditions", "/terms"],
          ["distributor-terms", "Distributor T&C", "/distributors/terms"],
          ["distributor-privacy", "Distributor Privacy", "/distributors/privacy"]].map(([k, label]) => (
          <button key={k} data-testid={`legal-tab-${k}`} onClick={() => setKey(k)}
            className={`text-sm font-semibold rounded-md px-4 py-1.5 ${key === k ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-600"}`}>{label}</button>
        ))}
        <a data-testid="legal-view-public"
          href={{ privacy: "/privacy-policy", terms: "/terms", "distributor-terms": "/distributors/terms", "distributor-privacy": "/distributors/privacy" }[key]}
          target="_blank" rel="noreferrer"
          className="ml-auto flex items-center gap-1.5 text-sm text-gray-600 hover:text-gray-900 border border-gray-300 rounded-md px-3 py-1.5">
          <Eye size={14} /> View public page
        </a>
      </div>
      {!doc ? <p className="text-sm text-gray-400">Loading…</p> : (
        <div className="space-y-3">
          <input data-testid="legal-title-input" value={title} onChange={(e) => setTitle(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <textarea data-testid="legal-content-input" value={content} onChange={(e) => setContent(e.target.value)} rows={26}
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-[13px] font-mono leading-relaxed focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-400 flex items-center gap-1"><Scales size={13} />
              Last updated {new Date(doc.updated_at).toLocaleString()} by {doc.updated_by}</span>
            <button data-testid="legal-save-btn" onClick={save} disabled={saving || !content.trim()}
              className="flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-md px-5 py-2 transition-colors disabled:opacity-50">
              <FloppyDisk size={14} /> {saving ? "Saving…" : "Save & publish"}
            </button>
          </div>
        </div>
      )}
    </AdminShell>
  );
}
